/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type CreateKeyValueRequest,
    CreateKeyValueRequestFromJSON,
    CreateKeyValueRequestToJSON,
} from '../models/CreateKeyValueRequest';
import {
    type CreateKeyValueResponse,
    CreateKeyValueResponseFromJSON,
    CreateKeyValueResponseToJSON,
} from '../models/CreateKeyValueResponse';
import {
    type UpdateKeyValueRequest,
    UpdateKeyValueRequestFromJSON,
    UpdateKeyValueRequestToJSON,
} from '../models/UpdateKeyValueRequest';

export interface CreateRequest {
    createKeyValueRequest: CreateKeyValueRequest;
}

export interface GetRequest {
    id: string;
}

export interface PutRequest {
    id: string;
    updateKeyValueRequest: UpdateKeyValueRequest;
}

/**
 * 
 */
export class KeyValueApi extends runtime.BaseAPI {

    /**
     * Creates request options for create without sending the request
     */
    async createRequestOpts(requestParameters: CreateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['createKeyValueRequest'] == null) {
            throw new runtime.RequiredError(
                'createKeyValueRequest',
                'Required parameter "createKeyValueRequest" was null or undefined when calling create().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/keyvalue`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateKeyValueRequestToJSON(requestParameters['createKeyValueRequest']),
        };
    }

    /**
     */
    async createRaw(requestParameters: CreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateKeyValueResponse>> {
        const requestOptions = await this.createRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateKeyValueResponseFromJSON(jsonValue));
    }

    /**
     */
    async create(requestParameters: CreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateKeyValueResponse> {
        const response = await this.createRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for get without sending the request
     */
    async getRequestOpts(requestParameters: GetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling get().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/keyvalue/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getRaw(requestParameters: GetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const requestOptions = await this.getRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async get(requestParameters: GetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for put without sending the request
     */
    async putRequestOpts(requestParameters: PutRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling put().'
            );
        }

        if (requestParameters['updateKeyValueRequest'] == null) {
            throw new runtime.RequiredError(
                'updateKeyValueRequest',
                'Required parameter "updateKeyValueRequest" was null or undefined when calling put().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/keyvalue/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateKeyValueRequestToJSON(requestParameters['updateKeyValueRequest']),
        };
    }

    /**
     */
    async putRaw(requestParameters: PutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateKeyValueResponse>> {
        const requestOptions = await this.putRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateKeyValueResponseFromJSON(jsonValue));
    }

    /**
     */
    async put(requestParameters: PutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateKeyValueResponse> {
        const response = await this.putRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
